import React from 'react'
import styled from 'styled-components'

// Elements
import Modal from 'components/elements/Modal'

// Calendly
import { InlineWidget } from 'react-calendly'

const StyledModal = styled(Modal)`
  & .styled-modal {
    position: relative;
    color: ${({ theme }) => theme.color.text.main};
  }

  & .form-mandatory-message {
    display: none;
  }

  & .exit-button {
    position: absolute;
    right: 15px;
    top: 15px;

    & svg path {
      fill: ${({ theme }) => theme.color.text.main};
    }

    &:hover {
      opacity: .5;
    }
  }

  & h2 {
    font-size: ${({ theme }) => theme.font.size.l};
  }

  & h3 {
    font-size: ${({ theme }) => theme.font.size.xsm};
  }
`

const ModalFrame = styled.div`
  border-top: 1px solid ${({ theme }) => theme.color.face.secondaryDark};
  width: 100%;
  height: 660px;
  overflow: hidden;
`

const Demo = ({ 
  onClose, 
  title = 'Niet de verbinding gevonden die bij je past?', 
  description = 'Geen probleem! Plan hieronder een afspraak. Dan bekijken wij samen de mogelijkheden voor jouw bedrijf.' 
}) => (
  <StyledModal>
    <h2 className=""><strong>{title}</strong></h2>
    <h3 className="font-size-xsm">{description}</h3>
    <button className="exit-button" type="button" onClick={onClose}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
    </button>

    <ModalFrame className="mt-4 exit-form">
      <InlineWidget url="https://calendly.com/123zakelijkinternet/123zakelijkinternet-demo?embed_type=Inline&hide_event_type_details=1&hide_gdpr_banner=1&text_color=17546d&primary_color=f3954a" />
    </ModalFrame>
  </StyledModal>
)

export default Demo